import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ScriptQuestionComponent, getPhotoCaptureQuestionnaireId, hasPhotoCaptureContextUpdated, getPhotoCaptureCompanyCode, getPhotoCaptureContextId, photoCaptureUpdateContextDataAction, getPhotoCaptureIsTermsAndConditionAccepted, photoCaptureResetContextAction, photoCaptureUpdateTncAction, getPhotoCaptureFraudStatement, getPhotoCaptureFraudWarningAccept, getPhotoCapturePbeAsgTaskId, getPhotoCaptureAssignmentType, getPhotoCaptureIsFraudWarningApiStatus, getPhotoCaptureDisableLibrary, photoCaptureGetFraudWarningDataAction, photoCaptureUpdateFraudWarningAcceptAction, getPhotoCaptureAttachmentInfo } from "../../../domain/photoCapture";
import { getConfigurationDataAction } from "../../../domain/brandedNotification";
import { getQuestionnaireEvaluationQuestionAttributeType, getQuestionnaireEvaluationQuestion, hasQuestionnaireEvaluationSaved, getQuestionnaireEvaluationQuestionnaireQuestionId, questionnaireEvaluationSaveRequestAction, questionnaireEvaluationQuestionGetAction } from "../../../domain/questionnaireEvaluation";
import { getGPCTheme } from '../selectors';
import { getGPCEvaluationDocId } from '../utilities';
const mapStateToProps = (state) => {
    return {
        appTheme: getGPCTheme(state),
        questionText: getQuestionnaireEvaluationQuestion(state),
        questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
        isSaveSuccess: hasQuestionnaireEvaluationSaved(state),
        evaluationDocId: getGPCEvaluationDocId(state),
        questionnaireId: getPhotoCaptureQuestionnaireId(state),
        questionnaireQuestionId: getQuestionnaireEvaluationQuestionnaireQuestionId(state),
        isContextUpdated: hasPhotoCaptureContextUpdated(state),
        photoCaptureAttachmentInfo: getPhotoCaptureAttachmentInfo(state),
        companyCode: getPhotoCaptureCompanyCode(state),
        contextId: getPhotoCaptureContextId(state),
        isTermsAndConditionAccepted: getPhotoCaptureIsTermsAndConditionAccepted(state),
        fraudStatement: getPhotoCaptureFraudStatement(state),
        fraudWarningAccept: getPhotoCaptureFraudWarningAccept(state),
        pbeAsgTaskId: getPhotoCapturePbeAsgTaskId(state),
        assignmentType: getPhotoCaptureAssignmentType(state),
        isFraudWarningApiStatus: getPhotoCaptureIsFraudWarningApiStatus(state),
        disableLibrary: getPhotoCaptureDisableLibrary(state)
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        questionnaireEvaluationQuestionGetAction,
        questionnaireEvaluationSaveRequestAction,
        photoCaptureUpdateContextDataAction,
        photoCaptureResetContextAction,
        photoCaptureUpdateTncAction,
        photoCaptureGetFraudWarningDataAction,
        photoCaptureUpdateFraudWarningAcceptAction,
        getConfigurationDataAction
    }, dispatch);
};
export const ConnectedScriptQuestion = connect(mapStateToProps, mapDispatchToProps)(ScriptQuestionComponent);
//# sourceMappingURL=ConnectedScriptQuestion.js.map